import { render, staticRenderFns } from "./NetworkSettings.vue?vue&type=template&id=20bf4eea"
import script from "./NetworkSettings.vue?vue&type=script&lang=ts"
export * from "./NetworkSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports